import DeleteIcon from "@mui/icons-material/Delete"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import lessonService from "services/lessonService"
import { removeLesson } from "slices/lessonSlice"
import { hiabColors } from "theme"
import type { ILesson } from "types/lessonTypes"

type Props = {
  lesson: ILesson
}

export function DeleteLessonDialog({ lesson }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const handleClickDeleteApp = () => {
    setIsLoading(true)

    lessonService
      .deleteLesson(lesson.id)
      .then((_resp) => {
        dispatch(removeLesson(lesson))
        setIsLoading(false)
        handleClose()
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <DeleteIcon sx={{ marginRight: 1 }} />
        Delete
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{`Delete ${lesson.name}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to delete ${lesson.name} lesson?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Box sx={{ m: 1, position: "relative" }}>
            <Button
              onClick={handleClickDeleteApp}
              disabled={isLoading}
              variant="contained"
              sx={{ backgroundColor: hiabColors.redPrimary }}
            >
              Delete
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  )
}
